<div class="flex flex-col flex-auto min-w-0">
    <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b" style="background-color:white;">
        <div class="text-4xl font-extrabold tracking-tight">Calendrier</div>
    </div>


    <mwl-demo-utils-calendar-header [(view)]="view" [(viewDate)]="viewDate">
    </mwl-demo-utils-calendar-header>

    <div style="width:100%; padding:20px;">
        <mwl-calendar-month-view
          [viewDate]="viewDate"
          [events]="events"
          [activeDayIsOpen]="true"
          (dayClicked)="dayClicked($event.day)"
          (eventClicked)="eventClicked($event)">
        </mwl-calendar-month-view>
    </div>
</div>
